import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import drEasyApi from '../Api/Customapi';

export const SUPPLIERS_QUERY_KEY = ['suppliers'];

export const useGetSuppliers = () => {
    return useQuery({
        queryKey: SUPPLIERS_QUERY_KEY,
        queryFn: async () => {
            const res = await drEasyApi.get('/api/Equipments/GetMySuppliers');
            return res.data || [];
        },
        onError: (err) => {
            if (err.response?.status === 403) {
                window.location.href = "/sub";
            } else {
                message.error('Failed to fetch suppliers');
            }
        }
    });
};

export const useAddSupplier = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (values) => {
            return await drEasyApi.post('/api/Equipments/AddSupplier', {
                supplier: values
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(SUPPLIERS_QUERY_KEY);
            message.success('Supplier added successfully');
        },
        onError: (err) => {
            if (err?.response?.status === 400) {
                const errorMessage = err?.response?.data?.message || 'Please check your input and try again';
                message.error(errorMessage);
            } else {
                message.error('Failed to add supplier');
            }
        }
    });
};

export const useEditSupplier = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ supplierId, values }) => {
            return await drEasyApi.put('/api/Equipments/EditSupplier', {
                supplierId: supplierId,
                supplier: values
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(SUPPLIERS_QUERY_KEY);
            message.success('Supplier updated successfully');
        },
        onError: (err) => {
            if (err?.response?.status === 400) {
                const errorMessage = err?.response?.data?.message || 'Please check your input and try again';
                message.error(errorMessage);
            } else {
                message.error('Failed to update supplier');
            }
        }
    });
};

export const useDeleteSupplier = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id) => {
            return await drEasyApi.delete('/api/Equipments/DeleteSupplier', { 
                params: { SupplierId: id } 
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(SUPPLIERS_QUERY_KEY);
            message.success('Supplier deleted successfully');
        },
        onError: () => {
            message.error('Failed to delete supplier');
        }
    });
};